import { render } from "./CustomerAccounting.vue?vue&type=template&id=73f2843c"
import script from "./CustomerAccounting.vue?vue&type=script&lang=js"
export * from "./CustomerAccounting.vue?vue&type=script&lang=js"
script.render = render

export default script